"use client"

import React from "react"

interface StepperProps {
    value: number
    onChange: (value: number) => void
    min?: number
    max?: number
    decrementLabel?: string
    incrementLabel?: string
}

export default function Stepper({
    value,
    onChange,
    min = 0,
    max = 99,
    decrementLabel = "Diminuer",
    incrementLabel = "Augmenter",
}: StepperProps) {
    const button =
        "flex h-9 w-9 items-center justify-center rounded-full border border-rm-blue-accent bg-white text-[18px] text-rm-blue-accent disabled:opacity-40"

    return (
        <div className="flex items-center gap-4">
            <button
                type="button"
                className={button}
                onClick={() => onChange(value - 1)}
                disabled={value <= min}
                aria-label={decrementLabel}
            >
                −
            </button>
            <span className="min-w-[1ch] text-center text-[18px] text-pale">{value}</span>
            <button
                type="button"
                className={button}
                onClick={() => onChange(value + 1)}
                disabled={value >= max}
                aria-label={incrementLabel}
            >
                +
            </button>
        </div>
    )
}
